import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Bases} from '../models/bases';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Bases';

@Injectable({
  providedIn: 'root'
})
export class BasesService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  save(base: Bases)
  {
    return this._http.post({ url: baseUrl + '/Save', body: base });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

}

